export const REMOVE_FROM_BOARD = 'removeFromBoard';
export const DESTROY_USER = 'destroyUser';
